import { mutatorAction } from 'satcheljs';
import { getStore, getCopilotChatDrawerState, getInitialState } from '../store/store';
import { EXPANDED_COPILOT_CHAT_DRAWER_WIDTH_CANVAS_RATIO } from '../utils/copilotChatDrawerConstants';

/**
 * Updates the appCanvasWidth for the given window.
 *
 * This function also creates the state for the window if it doesn't exist,
 * as setting the appCanvasWidth can be called before a drawer is open.
 */
export const setAppCanvasWidthMutator: (targetWindow: Window, width: number) => void =
    mutatorAction('setAppCanvasWidthMutator', (targetWindow: Window, width: number): void => {
        const state = getCopilotChatDrawerState(targetWindow);
        if (state) {
            state.appCanvasWidth = width;
        } else {
            // Initialize initial instance of this state for this target window
            // If we're setting appCanvasWidth before the drawer was ever opened, we aim for
            // the preferred width of drawer * default expanded ratio. Otherwise, we stay with default width.
            const newState = getInitialState();
            newState.appCanvasWidth = width;
            newState.userPreferredWidth = width * EXPANDED_COPILOT_CHAT_DRAWER_WIDTH_CANVAS_RATIO;
            getStore().chatDrawerStateMap.set(targetWindow, newState);
        }
    });
